export const RESERVATION_BANNER = "RESERVATION_BANNER";

export const VALID_PATH_SEGMENTS = [
  "saved-lists",
  "shared-board",
  "prd",
  "grp"
];
